export default "__VITE_ASSET__B675bb3$__"